var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.fieldSelectItems,"label":_vm.fieldKey,"value":_vm.value,"item-text":"label","item-value":"id","dense":"","outlined":""},on:{"input":_vm.handleOnInput}})}
var staticRenderFns = []

export { render, staticRenderFns }